export enum Feature {
  ACTIVE_OFFLINE_DETECTION = 'active-offline-detection',
  AUDIT_LOGGING = 'audit-logging',
  AUTH_REPORTING = 'auth-reporting',
  BATCH_UPDATE = 'batch-update',
  DIAGNOSTICS_RETRIEVAL = 'diagnostics-retrieval',
  FIRMWARE_MANAGEMENT = 'firmware-management',
  IAM = 'iam',
  LOAD_BALANCING = 'load-balancing',
  LOCAL_AUTHORIZATION = 'local-authorization',
  LOCAL_TOKEN_GROUP = 'local-token-group',
  LOCATIONS = 'pools',
  OCPI_TOKEN_GROUPS = 'ocpi-token-group',
  ONBOARDING = 'onboarding',
  ROAMING = 'roaming',
  TAGS = 'tags'
}
